import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { instalarRegistroPersistente } from './data/diagnostico.js';
import { logger } from './lib/logger.js';

// Antes de dibujar nada: si algo falla durante el arranque, el motivo tiene que
// quedar escrito en algun sitio que sobreviva al cierre de la aplicacion.
instalarRegistroPersistente();

const root = document.getElementById('root');
if (!root) throw new Error('No existe el nodo #root');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

globalThis.addEventListener('unhandledrejection', (event) => {
  logger.error('ui', 'UNHANDLED_REJECTION', 'Promesa sin manejar', {
    message: event.reason instanceof Error ? event.reason.message : String(event.reason),
  });
});
